import * as ActionTypes from "@mds/common/constants/actionTypes";

export const storeMineWorkInformations = (payload) => ({
  type: ActionTypes.STORE_MINE_WORK_INFORMATIONS,
  payload,
});
